/*
 * @Author: 蒋时阳
 * @Date: 2025-03-03 10:44:01
 * @LastEditors: 蒋时阳
 * @Description: 新版投保页的 store
 */
import Vue from 'vue';
import OrderFun from '@/util/orderFun';
import { _cloneObj, _noValue, _for, _formatDate, _toJson } from 'tools';
import { cloneDeep, omit, get } from 'lodash';
import { processClauses } from '@/util/clause';

/**
 * 获取新建的保障计划
 * 2025 新模板专用
 * */
export const getNewSchemeNew = ({ defaultPlan, noProfessions, firstOfCareeType }) => {
  let professions = [];
  if (!noProfessions) {
    professions = [OrderFun.getEmptyProfession(false, firstOfCareeType)];
  }
  let scheme = {
    planList: cloneDeep(defaultPlan.planList), //投保计划
    professions: professions, //选择的职业信息，以及相关的人员信息
    planClauseList: defaultPlan.planClauseList,
    careerTypeList: defaultPlan.careerTypeList,
  };
  // if (get(defaultPlan, 'planCodes.length')) {
  //   scheme.planCodes = defaultPlan.planCodes;
  //   scheme.planCodesValue = defaultPlan.planCodesValue;
  //   scheme.planCodesIsOpen = false;
  // }
  return scheme;
};

/**
 * 从订单参数中重新组装 schemes 以符合前端使用-新配置专用
 * @param {*} orderParams
 * @returns
 */
export const getSchemesFromOrderParams = (orderParams, state) => {
  const { allClauseList = [] } = state;
  const { insuranceInputData, personsInfo, isOrderDetailPage = false } = orderParams;
  let schemes = [];
  const { schemeList } = insuranceInputData;
  // 计划维度责任
  const latestPlanClauseList = processClauses(allClauseList, 1);
  if (get(schemeList, 'length')) {
    schemes = schemeList.map((scheme) => {
      let newPlanClauseList = [];
      if (isOrderDetailPage || !latestPlanClauseList.length) {
        // 因为订单详情页需要展示下单时的责任， 不管责任有增加还是减少，都应该是下单时选的责任
        newPlanClauseList = scheme.clauses;
      } else {
        newPlanClauseList = latestPlanClauseList.map((item) => {
          return {
            ...item,
            selected:
              scheme.clauses.find((clause) => clause.clauseCode === item.clauseCode).selected ||
              item.selected,
          };
        });
      }
      return {
        perPrice: scheme.perPrice || null, // 保费/人
        premium: scheme.premium || null, // 保费
        // 因为填充上一次投保的参数时，如果新增了责任，则也需要增加到新投保的计划里
        planClauseList: newPlanClauseList,
        careerTypeList: scheme.careerTypeList,
        planList: [],
        professions: scheme.jobs.map((job) => {
          const personList = personsInfo
            .filter(
              (person) => person.occupationCode === job.jobCode
              // 目前多计划职业细类是不可相同的，所以职业code相同则肯定是那个计划下的
              // +person.productCombId === +scheme.productCombId
            )
            .map((person) => {
              return {
                ...omit(person, ['occupationCode', 'productCombId']),
                occupationTypeVal: job.jobType,
                occupationType: OrderFun.getJobType(job.jobType),
              };
            });
          return {
            code: job.jobCode,
            des: job.des,
            num: job.peopleNum,
            val: job.jobType,
            occupationType: OrderFun.getJobType(job.jobType),
            expend: false,
            expendNum: 3,
            personsInfo: personList,
            perPrice: job.perPrice,
            premium: job.premium,
          };
        }),
        // tempJobs: scheme.tempJobs,
      };
    });
  }
  return schemes;
};

export default {
  state: {
    orderClauseList: [],
    allClauseList: [],
    // 老产品中的ageRestrict，ageRestrictObj，ageRestrictData相关，之前写的太反人类了，新模板重新写一下
    ageLimit: {
      // 1: 男，2: 女
      1: {
        minAge: 18,
        maxAge: 65,
      },
      2: {
        minAge: 18,
        maxAge: 65,
      },
    }, // 年龄限制
  },
  getters: {
    isNewConfigType(state) {
      return state.base.configType === 6;
    },
    schemesInfoNew(state, getters) {
      // console.log('getting schemesInfo...')
      let schemesInfo = [];
      for (let i = 0; i < state.schemes.length; i++) {
        let scheme = state.schemes[i];
        schemesInfo.push(OrderFun.checkAndCalculateScheme(scheme, i, state, getters));
      }
      //价格前置
      // schemesInfo = OrderFun.getTwiceTransformSchemesInfo(state, schemesInfo);
      return schemesInfo;
    },
    // 获取改造后的试算保费入参
    getInsuranceInputData(state, getters) {
      let params = {
        productId: state.productId,
        duration: get(state, 'duration.duration', undefined),
        durationUnit: get(state, 'duration.durationUnit', undefined),
        planCode: state.planCode,
        validStartDate: state.validStartDate,
        validEndDate: state.validEndDate,
        orderClauses: state.orderClauseList,
        schemeList: null, // 需要后面计算
      };

      params.schemeList = state.schemes.map((schemeItem, schemeIndex) => {
        return {
          peopleNum: schemeItem.professions.reduce((prev, cur) => prev + cur.num, 0),
          clauses: schemeItem.planClauseList,
          jobs: schemeItem.professions.map((pitem) => ({
            jobCode: pitem.code,
            des: pitem.des,
            peopleNum: pitem.num,
            // 职业类型，没选职业默认会填充 1 类，所以这里判空就不传
            jobType: pitem.code ? pitem.val : null,
            perPrice: pitem.perPrice,
            premium: pitem.premium,
          })),
          productCombId: String(schemeIndex + 1),
          careerTypeList: schemeItem.careerTypeList || state.defaultPlan.careerTypeList,
          // perPrice: schemeItem.perPrice,
          premium: schemeItem.premium,
        };
      });

      return params;
    },
  },
  mutations: {
    addNewSchemeNew(state) {
      // let scheme = OrderFun.getNewScheme(state.frontControlInfo.isAX, state.defaultPlan)
      // const deductibleRate = state.schemes && state.schemes[0] && state.schemes[0].deductibleRate;
      let defaultPlan = state.defaultPlan;
      console.log('🚀 ~ addNewSchemeNew ~ defaultPlan:', defaultPlan);
      let scheme = getNewSchemeNew({
        defaultPlan,
        firstOfCareeType: state.frontControlInfo.careerType[0],
      });

      state.schemes.push(scheme);
    },

    setOrderClauseList(state, orderClauseList) {
      state.orderClauseList = orderClauseList;
    },
    setOneScheme(state, payload) {
      const { schemeIndex, scheme } = payload;
      Vue.set(state.schemes, schemeIndex, scheme);
    },
    setAllClauseList(state, allClauseList) {
      state.allClauseList = allClauseList;
    },
    setAgeLimit(state, restrict) {
      if (!restrict.ageRestrict) {
        // 男女一致
        state.ageLimit = {
          1: {
            minAge: restrict.minAge || 18,
            maxAge: restrict.maxAge || 65,
          },
          2: {
            minAge: restrict.minAge || 18,
            maxAge: restrict.maxAge || 65,
          },
        };
      } else {
        try {
          const ageRestrict = JSON.parse(restrict.ageRestrict || '{}').ageRestrict;
          state.ageLimit = {
            1: ageRestrict.find((item) => item.isMan === 1),
            2: ageRestrict.find((item) => item.isMan === 0),
          };
        } catch (error) {
          console.log('🎢 setAgeLimit error', error);
        }
      }
    },
  },

  actions: {
    initStoreByOrderParamsNew({ commit, state }, params) {
      console.log('=== initStoreByOrderParamsNew == ', params);
      return new Promise((resolve, reject) => {
        if (params.tempId) {
          commit('save', {
            key: 'unfinishStartDate',
            value: params.validStartDate,
          });
        }
        if (params.history) {
          commit('save', {
            key: 'historyStartDate',
            value: params.validStartDate,
          });
        }
        // if (params.tempId && !params.unFinish) {
        //   commit('addEmptyProfession');
        //   console.log('该条数据是老数据');
        //   resolve();
        //   return;
        // }

        /* 共同被保险人 */
        // if (params.coInsuranceCompanyList && params.coInsuranceCompanyList.length) {
        //   state.coInsuranceCompanyList = params.coInsuranceCompanyList;
        // }
        try {
          // if (params.recommend) {
          //   //续保推荐
          //   params.groupApplicant = {
          //     groupContact: params.groupApplicant.groupContact
          //       ? params.groupApplicant.groupContact
          //       : null,
          //     contactCall: params.groupApplicant.contactCall
          //       ? params.groupApplicant.contactCall
          //       : null,
          //     landline: params.groupApplicant.landline ? params.groupApplicant.landline : null,
          //     groupEmail: params.groupApplicant.groupEmail
          //       ? params.groupApplicant.groupEmail
          //       : null,
          //   };
          // }

          commit('setOrderParams', params);
          commit('setAgeRestrictData', params);
          commit('setGroupApplicant', params.groupApplicant);

          // 建工险新增
          if (params.groupApplicant.constructionCertificate) {
            commit(
              'setConstructionCertificate',
              JSON.parse(params.groupApplicant.constructionCertificate)
            );
          }
          if (params.groupApplicant.legalPersonCardUrls) {
            commit('setLegalPersonCardUrls', JSON.parse(params.groupApplicant.legalPersonCardUrls));
          }

          // 民宿信息
          if (params.orderInfoExtend) {
            commit('setOrderInfoExtend', params.orderInfoExtend);
          }

          // console.log('params.authorizationBookList', params.authorizationBookList);
          if (params.authorizationBookList) {
            commit('setAuthorizationBookList', params.authorizationBookList);
          }

          if (params.archiveInfo) {
            let archiveInfo = JSON.parse(params.archiveInfo);
            if (archiveInfo.authorizationBookList) {
              commit('setAuthorizationBookList', archiveInfo.authorizationBookList.split(','));
            }
          }

          let constructionInfo = undefined;
          if (
            params.detailJson &&
            JSON.parse(params.detailJson) &&
            JSON.parse(params.detailJson).constructionInfo
          ) {
            constructionInfo = JSON.parse(params.detailJson).constructionInfo;
          } else if (params.constructionInfo) {
            constructionInfo = params.constructionInfo;
          }
          commit('setConstructionInfo', constructionInfo);
          commit('setBillInfoBean', params.billInfoBean);
          commit('setDuration', params.durationInfoBean);

          if (params && params.newProfessions && params.newProfessions.length) {
            commit('setSchemesProfessions', params.newProfessions);
          }

          if (params.insuranceInputData) {
            let schemes = [];
            // params.insuranceInputData是再次投保/续保/待完善等情况下接口保存的数据
            if (params.insuranceInputData) {
              schemes = getSchemesFromOrderParams(params, state);
            }
            console.log('回塞数据-schemes', schemes);
            commit('setSchemes', schemes);

            let orderClauseList = [];
            const latestOrderClauseList = processClauses(state.allClauseList, 0);
            // get(params, 'insuranceInputData.orderClauses')是/续保/待完善等情况下接口保存的数据
            const oldOrderClauseList = get(params, 'insuranceInputData.orderClauses', []);
            if (oldOrderClauseList) {
              if (params.isOrderDetailPage || !get(latestOrderClauseList, 'length')) {
                // 因为订单详情页需要展示下单时的责任， 不管责任有增加还是减少，都应该是下单时选的责任
                orderClauseList = oldOrderClauseList;
              } else {
                // 因为填充上一次投保的参数时，如果新增了订单维度责任，则也需要增加到新投保的计划里
                orderClauseList = latestOrderClauseList.map((item) => {
                  return {
                    ...item,
                    selected:
                      oldOrderClauseList.find((clause) => clause.clauseCode === item.clauseCode)
                        .selected || item.selected,
                  };
                });
              }
            } else {
              orderClauseList = latestOrderClauseList;
            }
            commit('setOrderClauseList', orderClauseList);
          }
        } catch (error) {
          reject(error);
        }
      });
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/writeStoreNew.js